var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 600",
    style: {
      enableBackground: "new 0 0 1000 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{fill:#E1EEFE;}\n\t.st3{fill:#EDF4FC;}\n\t.st4{fill:#BCD0E2;}\n\t.st5{fill:#B0BFDE;}\n\t.st6{fill:#D1DBEA;}\n\t.st7{fill:#E4EFFF;}\n\t.st8{fill:#253858;}\n\t.st9{fill:#FFC40E;}\n\t.st10{fill:#3BB6D5;}\n\t.st11{fill:none;stroke:#3D7AA8;stroke-width:4.8903;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#4C5C7D;stroke-width:4.8903;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#4A6178;stroke-width:4.8903;stroke-miterlimit:10;}\n\t.st14{fill:#FFAB01;}\n\t.st15{fill:#FEC12F;}\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:1.4725;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.6268;stroke-miterlimit:10;}\n\t.st18{fill:#D9E1E4;}\n\t.st19{fill:none;stroke:#BAC2C6;stroke-width:0.1506;stroke-miterlimit:10;}\n\t.st20{fill:#BAC2C6;}\n\t.st21{opacity:0.34;fill:#FFFFFF;}\n\t.st22{fill:#165670;}\n\t.st23{fill:none;stroke:#BAC2C6;stroke-width:0.1652;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#FFC40E;stroke-width:0.9515;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#3BB6D5;stroke-width:0.9515;stroke-miterlimit:10;}\n\t.st26{fill:#FFFFFF;stroke:#3BB6D5;stroke-width:0.9515;stroke-miterlimit:10;}\n\t.st27{fill:#FFFFFF;stroke:#FFC40E;stroke-width:0.9515;stroke-miterlimit:10;}\n\t.st28{fill:#367082;}\n\t.st29{fill:#88BDDA;}\n\t.st30{fill:#ACD5F4;}\n\t.st31{fill:#001F46;}\n\t.st32{fill:#2F91AA;}\n\t.st33{fill:#163F59;}\n\t.st34{fill:#194866;}\n\t.st35{fill:#93CEF5;}\n\t.st36{fill:#86BBD8;}\n\t.st37{fill:#C4D1E1;}\n\t.st38{fill:#E9D6B8;}\n\t.st39{fill:#B6C2C9;}\n\t.st40{fill:#D8E5ED;}\n\t.st41{fill:#879BA6;}\n\t.st42{fill:#E2C59C;}\n\t.st43{fill:none;stroke:#3BB6D5;stroke-width:0.9663;stroke-miterlimit:10;}\n\t.st44{fill:#0C1153;}\n\t.st45{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 1000,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.8,396.3l13.4-36.6l-18.1-11.4c0.6-5.5,0.8-11.1,0.7-16.7l19.8-8l-6.7-38.4l-23.6-0.9 c-2-4.5-4.3-8.9-6.8-13.2l14.4-18.4l-25-29.9l-22.3,11.8c-3.6-2.7-7.4-5.2-11.2-7.4l3.4-24.4l-36.6-13.4L172.5,211 c-4.3-0.6-8.7-0.9-13.2-1l-9.3-23l-38.4,6.7l-0.9,24.8c-4.4,1.7-8.6,3.7-12.8,5.8l-18.8-14.6l-29.9,25l10.8,20.4 c-3.3,4-6.4,8.3-9.2,12.7l-21.7-3l-13.4,36.6l17.6,11.1c-1.1,5.8-1.7,11.7-1.9,17.7l-18.1,7.3l6.7,38.4l18.5,0.7 c2.2,6.3,5,12.3,8.1,18.1l-10.7,13.7l25,29.9l15-7.9c5.4,4.5,11.2,8.6,17.3,12.1l-2.2,15.9l36.6,13.4l8.7-13.9 c7,1.1,14.1,1.6,21.4,1.5l6,14.8l38.4-6.7l0.6-17.2c6.4-2.6,12.6-5.7,18.4-9.3l13.4,10.5l29.9-25l-8.9-16.8 c3.8-5,7.2-10.3,10.2-15.9L284.8,396.3z M165.3,387.2c-29.1,5.1-56.8-14.3-61.8-43.4c-5.1-29.1,14.3-56.8,43.4-61.8 c29.1-5.1,56.8,14.3,61.8,43.4C213.8,354.4,194.4,382.1,165.3,387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.9,253.2c-44.9,7.9-75,50.7-67.1,95.6c7.9,44.9,50.7,75,95.6,67.1c44.9-7.9,75-50.7,67.1-95.6 C229.6,275.4,186.8,245.4,141.9,253.2z M167.4,399.1c-35.6,6.2-69.5-17.6-75.8-53.2c-6.2-35.6,17.6-69.5,53.2-75.8 c35.6-6.2,69.5,17.6,75.8,53.2C226.8,358.9,203,392.8,167.4,399.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M708.4,238.4l9.5-37.9l-19.2-9.5c0-5.6-0.3-11.2-1-16.8l18.9-10l-10.7-37.5l-23.6,1.6 c-2.5-4.3-5.2-8.5-8.1-12.4l12.4-19.9l-28-27.2l-21,14c-3.9-2.3-7.9-4.4-12-6.3l0.9-24.7l-37.9-9.5l-11.3,23 c-4.4-0.1-8.8,0-13.2,0.3l-11.7-22l-37.5,10.7l1.7,24.8c-4.2,2.2-8.2,4.5-12.1,7.1l-20.2-12.6l-27.2,28l12.9,19.2 c-2.9,4.4-5.5,8.9-7.9,13.6l-21.9-0.8l-9.5,37.9l18.7,9.2c-0.4,5.9-0.5,11.9,0,17.9l-17.3,9.2l10.7,37.6l18.5-1.2 c2.9,6,6.2,11.8,10,17.2l-9.2,14.7l28,27.2L504,294c5.9,3.9,12.1,7.4,18.5,10.3l-0.6,16.1l37.9,9.5l7.3-14.8 c7.1,0.4,14.3,0.2,21.5-0.7l7.5,14.1l37.5-10.7l-1.1-17.2c6.2-3.3,12-7,17.4-11.2l14.5,9l27.2-28l-10.6-15.8 c3.2-5.4,6.1-11,8.5-16.9L708.4,238.4z M588.4,241.8c-28.4,8.1-58-8.4-66.1-36.8c-8.1-28.4,8.4-58.1,36.8-66.1 c28.4-8.1,58,8.4,66.1,36.8C633.3,204.1,616.8,233.7,588.4,241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M551.1,110.8c-44,12.5-69.5,58.3-56.9,102.3c12.5,44,58.3,69.4,102.3,56.9c44-12.5,69.4-58.3,56.9-102.2 C640.8,123.7,595,98.2,551.1,110.8z M591.7,253.4c-34.8,9.9-71.1-10.3-81-45.1c-9.9-34.8,10.3-71.1,45.1-81 c34.8-9.9,71.1,10.3,81,45.1C646.7,207.2,626.5,243.5,591.7,253.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M867,222.3l13.9-18.1l-8.1-9.5c1.3-3,2.4-6.1,3.4-9.2l12.5-1l3-22.6l-13-4.7c-0.3-2.9-0.8-5.7-1.4-8.5 l11.3-7.7l-8.7-21.1l-14.5,2.6c-1.5-2.1-3.2-4.2-5-6.1l6.2-13.1l-18.1-13.9L837.1,99c-2.3-1.1-4.7-2.1-7.2-2.9l-1.1-14.5l-22.6-3 l-4.9,13.7c-2.8,0.2-5.5,0.5-8.2,1l-7.9-11.5l-21.1,8.7l2.4,13.3c-2.6,1.7-5.1,3.5-7.4,5.5l-11.6-5.5l-13.9,18.1l7.9,9.3 c-1.6,3.1-3,6.3-4.2,9.6l-11.4,0.9l-3,22.6l10.2,3.7c0.1,3.9,0.6,7.8,1.3,11.5l-8.4,5.8l8.7,21.1l9.8-1.8 c2.2,3.5,4.7,6.8,7.5,9.8l-4.1,8.5l18.1,13.9l7.3-6.2c3.7,1.9,7.6,3.4,11.7,4.6l0.7,9.3l22.6,3l3.4-9.5c4.1-0.3,8.1-1,11.9-1.9 l5.6,8.2l21.1-8.7l-2-11c3-2.1,5.9-4.5,8.5-7.1L867,222.3z M801,203.1c-21-2.8-35.7-22.1-32.9-43.1c2.8-21,22.1-35.7,43.1-32.9 c21,2.8,35.7,22.1,32.9,43.1C841.3,191.2,822,206,801,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M813.4,110.5c-30.2-4-57.9,17.1-61.9,47.3c-4,30.2,17.1,57.9,47.3,61.9c30.2,4,57.9-17.1,61.9-47.3 C864.7,142.3,843.5,114.6,813.4,110.5z M800.3,208.4c-23.9-3.2-40.7-25.2-37.5-49.1c3.2-23.9,25.2-40.7,49.1-37.5 c23.9,3.2,40.7,25.2,37.5,49.1C846.1,194.8,824.2,211.6,800.3,208.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.6,450c64.4,3.1,263.8,12.1,385.2,11.6c225.1-0.9,407,32.6,285.1,51.8c-34.1,5.4,60.4,54.7-177.6,50.9 C558.4,561,347,530.1,244.7,516.2c-102.4-13.9-149-30.8-170.7-38.5C55,471,49.6,439.1,274.6,450z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 140.9,
    className: "st8",
    width: 355.4,
    height: 277.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.8,
    y: 123.7,
    className: "st2",
    width: 355.4,
    height: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.9,132c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C163.4,128.7,164.9,130.1,164.9,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.3,132c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C173.8,128.7,175.3,130.1,175.3,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M185.7,132c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C184.2,128.7,185.7,130.1,185.7,132z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 206.9,
    y1: 167.4,
    x2: 281.6,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 213.1,
    y1: 179.4,
    x2: 225.4,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 213.1,
    y1: 191.3,
    x2: 225.4,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 213.1,
    y1: 203.3,
    x2: 225.4,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 249.6,
    y1: 179.4,
    x2: 287.5,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 249.6,
    y1: 191.3,
    x2: 287.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 249.6,
    y1: 203.3,
    x2: 287.5,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 230.8,
    y1: 179.4,
    x2: 239.5,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 230.8,
    y1: 191.3,
    x2: 239.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 230.8,
    y1: 203.3,
    x2: 239.5,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 243.2,
    y1: 179.4,
    x2: 245.5,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 243.2,
    y1: 191.3,
    x2: 245.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 243.2,
    y1: 203.3,
    x2: 245.5,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 207.2,
    y1: 179.4,
    x2: 209.5,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 207.2,
    y1: 191.3,
    x2: 209.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 207.2,
    y1: 203.3,
    x2: 209.5,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 213.1,
    y1: 227.1,
    x2: 232.2,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 258.5,
    y1: 227.1,
    x2: 287.5,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 237.5,
    y1: 227.1,
    x2: 248.4,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 252.2,
    y1: 227.1,
    x2: 254.5,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 288.6,
    y1: 251,
    x2: 378.1,
    y2: 251
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 238.6,
    y1: 251,
    x2: 281.6,
    y2: 251
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 321.1,
    y1: 227.1,
    x2: 350.1,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 295.6,
    y1: 227.1,
    x2: 311,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 314.8,
    y1: 227.1,
    x2: 317.1,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 353,
    y1: 227.1,
    x2: 355.3,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 207.2,
    y1: 227.1,
    x2: 209.5,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 213.1,
    y1: 274.9,
    x2: 232.2,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 207.2,
    y1: 274.9,
    x2: 209.5,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 235.8,
    y1: 274.9,
    x2: 238.1,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 198.5,
    y1: 322.6,
    x2: 217.6,
    y2: 322.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 192.6,
    y1: 322.6,
    x2: 194.9,
    y2: 322.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 221.2,
    y1: 322.6,
    x2: 223.5,
    y2: 322.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 223.2,
    y1: 262.9,
    x2: 225.5,
    y2: 262.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 223.2,
    y1: 239.1,
    x2: 234.4,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 238.6,
    y1: 239.1,
    x2: 282.4,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 314.1,
    y1: 179.4,
    x2: 352,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 314.1,
    y1: 191.3,
    x2: 352,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 314.1,
    y1: 203.3,
    x2: 352,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 354,
    y1: 179.4,
    x2: 420.2,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 354,
    y1: 191.3,
    x2: 444.7,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 354,
    y1: 203.3,
    x2: 460.9,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 295.3,
    y1: 179.4,
    x2: 304,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 295.3,
    y1: 191.3,
    x2: 304,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 295.3,
    y1: 203.3,
    x2: 304,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 307.8,
    y1: 179.4,
    x2: 310.1,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 307.8,
    y1: 191.3,
    x2: 310.1,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 307.8,
    y1: 203.3,
    x2: 310.1,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 428.9,
    y1: 179.4,
    x2: 431.2,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 451.2,
    y1: 191.3,
    x2: 453.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 466.4,
    y1: 203.3,
    x2: 468.7,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 206.9,
    y1: 215.2,
    x2: 281.6,
    y2: 215.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 197.9,
    y1: 348,
    x2: 210.3,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 226.8,
    y1: 371.9,
    x2: 239.2,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 263.3,
    y1: 371.9,
    x2: 345.3,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 207.7,
    y1: 360,
    x2: 327.9,
    y2: 360
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 244.5,
    y1: 371.9,
    x2: 253.2,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 257,
    y1: 371.9,
    x2: 259.3,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 192,
    y1: 348,
    x2: 194.3,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 213.1,
    y1: 348,
    x2: 215.4,
    y2: 348
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 243.4,
    y1: 383.8,
    x2: 249,
    y2: 383.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 237.5,
    y1: 383.8,
    x2: 239.8,
    y2: 383.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 251.8,
    y1: 383.8,
    x2: 254.1,
    y2: 383.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 259.1,
    y1: 407.7,
    x2: 264.7,
    y2: 407.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 253.2,
    y1: 407.7,
    x2: 255.5,
    y2: 407.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 267.5,
    y1: 407.7,
    x2: 269.8,
    y2: 407.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 220.9,
    y1: 371.9,
    x2: 223.2,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 253.5,
    y1: 395.8,
    x2: 372,
    y2: 395.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 348.1,
    y1: 371.9,
    x2: 350.4,
    y2: 371.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 206.9,
    y1: 286.8,
    x2: 309.6,
    y2: 286.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 206.9,
    y1: 298.8,
    x2: 359,
    y2: 298.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 206.9,
    y1: 310.7,
    x2: 258.5,
    y2: 310.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 167.4,
    x2: 171.5,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 179.4,
    x2: 171.5,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 191.3,
    x2: 171.5,
    y2: 191.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 203.3,
    x2: 171.5,
    y2: 203.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 215.2,
    x2: 171.5,
    y2: 215.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 227.1,
    x2: 171.5,
    y2: 227.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 239.1,
    x2: 171.5,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 251,
    x2: 171.5,
    y2: 251
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 262.9,
    x2: 171.5,
    y2: 262.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 274.9,
    x2: 171.5,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 286.8,
    x2: 171.5,
    y2: 286.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 298.8,
    x2: 171.5,
    y2: 298.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 310.7,
    x2: 171.5,
    y2: 310.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 322.6,
    x2: 171.5,
    y2: 322.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 334.6,
    x2: 171.5,
    y2: 334.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 346.5,
    x2: 171.5,
    y2: 346.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 165.9,
    y1: 358.5,
    x2: 171.5,
    y2: 358.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M131.6,319.8c0,0,2.2-6.6-0.3-12.8c-0.9-2.2-4.3-5.3-6.6-4.4c-2.3,0.9-3,4.5-1.7,7.7 C125.4,316.6,131.6,319.8,131.6,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135,330.3c0,0-3-5.3-8.3-7.3c-1.9-0.7-5.9-0.2-6.6,1.9c-0.8,2.1,1.1,4.7,3.9,5.7 C129.3,332.5,135,330.3,135,330.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M141.2,341.6c0,0-4.9-3.7-10.6-3.2c-2.1,0.2-5.5,2.2-5.3,4.4c0.2,2.2,2.9,3.8,5.9,3.6 C136.9,345.9,141.2,341.6,141.2,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.3,330.6c0,0,5.2-2.2,8.3-7c1.1-1.7,1.8-5.5,0.2-6.5c-1.5-1-4.2,0.5-5.8,3 C135,324.9,135.3,330.6,135.3,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M140.5,342c0,0,5.4-2.1,8.4-6.9c1.1-1.7,1.7-5.6,0.1-6.6c-1.6-1-4.3,0.4-5.9,2.9 C140,336.2,140.5,342,140.5,342z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M150.5,356.1c0,0,4.8-1.1,7.1-4.8c0.8-1.3,1-4.5-0.6-5.5c-1.6-1-4-0.2-5.2,1.8 C149.4,351.3,150.5,356.1,150.5,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M149.9,356.4c0,0-3.5-3.1-8.1-3.5c-1.7-0.1-4.6,0.9-4.8,2.5c-0.1,1.6,1.9,3,4.3,3.2 C145.9,359,149.9,356.4,149.9,356.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M177.3,420.6c-1.1,1-2,1.3-2.1,1.4l-0.4-1.1l0.2,0.5l-0.2-0.5c0.1,0,2.6-0.9,3.7-4.7 c1.3-4.2,0.4-10.2-2.6-17.8c-4.1-10.4-12.2-23.5-24.1-39c-13.8-18-17.6-29.7-20.1-37.4c-0.6-2-1.2-3.7-1.8-5.1l1.1-0.5 c0.6,1.5,1.2,3.2,1.9,5.2c2.5,7.7,6.3,19.3,19.9,37.1c26.4,34.4,29.2,50.4,26.9,57.8C179.1,418.5,178.2,419.8,177.3,420.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M507.8,429.9c26.5-14.4,6.3-20.6-18-21.5c12.2-10.7,5.3-21.6-23.4-34.8c-12.9-5.9-28.8-3.5-44.7,2.8 c-11.3-22.3-27-38-46-30.6c-15.7,6.1-27.5,13.7-35,22.1c-4.7-2-9.9-3.9-15.3-5.7c-11.9-3.9-20.9-1.6-27.6,4.4 c-23.2-14-46.8-22.6-61.2-14.2c-25,14.7-28.7,27.9-13.2,41.7c-24.3-0.2-42.9,6.5-11.8,25.6c-28.8-4.1-49.5-2.1-37.7,14.7 c26.2,37.5,155.4,48.9,252.6,36.2c61.1-0.6,112.2-9,122.7-27.1C556.8,430.3,535.6,427.8,507.8,429.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M185.5,398.6c26.9,11.9,44.7,36,49.9,63.2c-23.5,14.5-53.3,17.6-80.3,5.7c-26.9-11.9-44.7-36-49.9-63.1 C128.7,389.8,158.6,386.7,185.5,398.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 115.7,
    y1: 408.4,
    x2: 230.6,
    y2: 459.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 139.3,
    y1: 419,
    x2: 120,
    y2: 428.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 158.9,
    y1: 427.6,
    x2: 135.1,
    y2: 438.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 178.5,
    y1: 436.3,
    x2: 138.8,
    y2: 455
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 198.1,
    y1: 444.9,
    x2: 159.5,
    y2: 463.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 217.7,
    y1: 453.6,
    x2: 196.2,
    y2: 463.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 137.1,
    y1: 417.6,
    x2: 130.9,
    y2: 397.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 156.7,
    y1: 426.2,
    x2: 147,
    y2: 394.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 176.3,
    y1: 434.9,
    x2: 164.1,
    y2: 395.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 195.9,
    y1: 443.6,
    x2: 183.4,
    y2: 402.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 215.5,
    y1: 452.2,
    x2: 204.7,
    y2: 417.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M260.3,376c18.4,26.8,21.2,59.8,10.3,88.3c-30.5,0-60.3-14.4-78.8-41.2c-18.4-26.8-21.2-59.8-10.3-88.3 C212.1,334.9,241.9,349.2,260.3,376z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 189,
    y1: 344.8,
    x2: 267.6,
    y2: 459.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 205.1,
    y1: 368.4,
    x2: 181.7,
    y2: 365.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 218.5,
    y1: 387.9,
    x2: 189.6,
    y2: 384.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 231.9,
    y1: 407.4,
    x2: 183.7,
    y2: 402.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 245.3,
    y1: 426.9,
    x2: 198.4,
    y2: 421.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 258.7,
    y1: 446.4,
    x2: 232.6,
    y2: 443.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 203.8,
    y1: 365.9,
    x2: 209.7,
    y2: 343.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 217.2,
    y1: 385.4,
    x2: 226.5,
    y2: 349.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 230.6,
    y1: 404.9,
    x2: 242.2,
    y2: 360.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 244,
    y1: 424.4,
    x2: 255.9,
    y2: 378.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 257.4,
    y1: 443.9,
    x2: 267.7,
    y2: 404.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.1,
    y: 209.8,
    className: "st4",
    width: 465.5,
    height: 265.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.1,
    y: 209.8,
    className: "st2",
    width: 465.5,
    height: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.1,218c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C323.7,214.7,325.1,216.2,325.1,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M335.5,218c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C334.1,214.7,335.5,216.2,335.5,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M345.9,218c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C344.5,214.7,345.9,216.2,345.9,218z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 362.5,
    y: 243.4,
    className: "st3",
    width: 400.6,
    height: 215.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 390.1,
    y: 266.6,
    className: "st18",
    width: 86.2,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 390.1,
    y: 259,
    className: "st18",
    width: 27.9,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.3,
    y: 266.6,
    className: "st18",
    width: 86.2,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.3,
    y: 392.4,
    className: "st9",
    width: 4.4,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.3,
    y: 401,
    className: "st18",
    width: 72.6,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 668.5,
    y: 392.4,
    className: "st10",
    width: 4.4,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 668.5,
    y: 401,
    className: "st18",
    width: 72.6,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 571.3,
    y: 259,
    className: "st18",
    width: 27.9,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 277.5,
    className: "st19",
    width: 134.6,
    height: 152.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 408.4,
    x2: 528.1,
    y2: 408.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 386.6,
    x2: 528.1,
    y2: 386.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 364.8,
    x2: 528.1,
    y2: 364.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 343,
    x2: 528.1,
    y2: 343
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 321.1,
    x2: 528.1,
    y2: 321.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 299.3,
    x2: 528.1,
    y2: 299.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 483.3,
    y1: 277.5,
    x2: 483.3,
    y2: 430.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 438.4,
    y1: 277.5,
    x2: 438.4,
    y2: 430.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 277.5,
    x2: 386.5,
    y2: 284.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 299.3,
    x2: 386.5,
    y2: 306.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 321.1,
    x2: 386.5,
    y2: 328.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 343,
    x2: 386.5,
    y2: 349.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 364.8,
    x2: 386.5,
    y2: 371.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 386.6,
    x2: 386.5,
    y2: 393.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 393.5,
    y1: 408.4,
    x2: 386.5,
    y2: 415.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M380.3,415.9L380.3,415.9l-0.7,0.4l-0.1-0.4l0.9-0.5h0.5v4h-0.5V415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,417.4c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,415.4,384.9,416.1,384.9,417.4z M382.8,417.4c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C383.1,415.8,382.8,416.4,382.8,417.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M379.2,397.8v-0.3l0.4-0.4c1-1,1.5-1.5,1.5-2.1c0-0.4-0.2-0.8-0.8-0.8c-0.4,0-0.7,0.2-0.8,0.3l-0.2-0.4 c0.3-0.2,0.7-0.4,1.1-0.4c0.9,0,1.2,0.6,1.2,1.2c0,0.7-0.5,1.3-1.4,2.1l-0.3,0.3v0h1.8v0.4H379.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,395.7c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,393.7,384.9,394.5,384.9,395.7z M382.8,395.8c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.6c0-1-0.2-1.6-0.8-1.6 C383.1,394.1,382.8,394.7,382.8,395.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M379.3,375.5c0.2,0.1,0.5,0.2,0.9,0.2c0.7,0,0.9-0.4,0.9-0.8c0-0.6-0.5-0.8-1-0.8h-0.3v-0.4h0.3 c0.4,0,0.9-0.2,0.9-0.7c0-0.3-0.2-0.6-0.7-0.6c-0.3,0-0.6,0.1-0.8,0.3l-0.1-0.4c0.2-0.2,0.6-0.3,1-0.3c0.8,0,1.1,0.5,1.1,0.9 c0,0.4-0.2,0.8-0.7,0.9v0c0.5,0.1,0.9,0.5,0.9,1c0,0.6-0.5,1.2-1.4,1.2c-0.4,0-0.8-0.1-1-0.3L379.3,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,374.1c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,372.1,384.9,372.8,384.9,374.1z M382.8,374.1c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C383.1,372.5,382.8,373.1,382.8,374.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M380.8,354.5v-1.1H379V353l1.8-2.5h0.6v2.5h0.6v0.4h-0.6v1.1H380.8z M380.8,353v-1.3c0-0.2,0-0.4,0-0.6 h0c-0.1,0.2-0.2,0.4-0.3,0.6l-1,1.3v0H380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,352.4c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,350.4,384.9,351.2,384.9,352.4z M382.8,352.5c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C383.1,350.8,382.8,351.4,382.8,352.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M381.5,329.3H380l-0.2,1c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.1,0.9,0.2c0.3,0.2,0.6,0.5,0.6,1 c0,0.8-0.6,1.4-1.5,1.4c-0.4,0-0.8-0.1-1-0.2l0.1-0.4c0.2,0.1,0.5,0.2,0.8,0.2c0.5,0,0.9-0.3,0.9-0.9c0-0.5-0.3-0.9-1.1-0.9 c-0.2,0-0.4,0-0.5,0l0.3-1.9h1.9V329.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,330.8c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,328.8,384.9,329.5,384.9,330.8z M382.8,330.8c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C383.1,329.2,382.8,329.8,382.8,330.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M381.4,307.6c-0.1,0-0.2,0-0.4,0c-0.8,0.1-1.3,0.8-1.4,1.4h0c0.2-0.2,0.5-0.5,1-0.5 c0.7,0,1.2,0.5,1.2,1.3c0,0.7-0.5,1.4-1.3,1.4c-0.8,0-1.4-0.7-1.4-1.7c0-0.8,0.3-1.4,0.7-1.8c0.3-0.3,0.8-0.5,1.3-0.6 c0.2,0,0.3,0,0.4,0V307.6z M381.3,309.9c0-0.6-0.3-0.9-0.8-0.9c-0.3,0-0.6,0.2-0.8,0.5c0,0.1-0.1,0.1-0.1,0.2 c0,0.7,0.3,1.1,0.9,1.1C381,310.8,381.3,310.4,381.3,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,309.1c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,307.1,384.9,307.9,384.9,309.1z M382.8,309.2c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C383.1,307.5,382.8,308.1,382.8,309.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M381.7,285.5v0.4l-1.7,3.6h-0.6l1.7-3.5v0h-1.9v-0.4H381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M384.9,287.5c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C384.5,285.5,384.9,286.2,384.9,287.5z M382.8,287.5c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.6c0-1-0.2-1.6-0.8-1.6 C383.1,285.9,382.8,286.5,382.8,287.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M407.7,438.2v-0.3l0.4-0.4c1-1,1.5-1.5,1.5-2.1c0-0.4-0.2-0.8-0.8-0.8c-0.4,0-0.7,0.2-0.8,0.3l-0.2-0.4 c0.3-0.2,0.7-0.4,1.1-0.4c0.9,0,1.2,0.6,1.2,1.2c0,0.7-0.5,1.3-1.4,2.1l-0.3,0.3v0h1.8v0.4H407.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M413.4,436.2c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C412.9,434.2,413.4,435,413.4,436.2z M411.3,436.3c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C411.6,434.6,411.3,435.2,411.3,436.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M415.1,434.8L415.1,434.8l-0.7,0.4l-0.1-0.4l0.9-0.5h0.5v4h-0.5V434.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M419.6,434.3v0.4l-1.7,3.6h-0.6l1.7-3.5v0h-1.9v-0.4H419.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M453.5,438.2v-0.3l0.4-0.4c1-1,1.5-1.5,1.5-2.1c0-0.4-0.2-0.8-0.8-0.8c-0.4,0-0.7,0.2-0.8,0.3l-0.2-0.4 c0.3-0.2,0.7-0.4,1.1-0.4c0.9,0,1.2,0.6,1.2,1.2c0,0.7-0.5,1.3-1.4,2.1l-0.3,0.3v0h1.8v0.4H453.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M459.2,436.2c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C458.7,434.2,459.2,435,459.2,436.2z M457.1,436.3c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C457.4,434.6,457.1,435.2,457.1,436.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M460.9,434.8L460.9,434.8l-0.7,0.4l-0.1-0.4l0.9-0.5h0.5v4h-0.5V434.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M462.8,437.2c0-0.5,0.3-0.9,0.8-1.1l0,0c-0.4-0.2-0.6-0.5-0.6-0.9c0-0.6,0.5-1.1,1.2-1.1 c0.8,0,1.2,0.5,1.2,1c0,0.3-0.2,0.7-0.7,0.9v0c0.5,0.2,0.8,0.5,0.8,1c0,0.7-0.6,1.2-1.3,1.2 C463.3,438.3,462.8,437.8,462.8,437.2z M464.9,437.2c0-0.5-0.3-0.7-0.9-0.9c-0.5,0.1-0.7,0.4-0.7,0.8c0,0.4,0.3,0.8,0.8,0.8 C464.6,437.9,464.9,437.6,464.9,437.2z M463.4,435.2c0,0.4,0.3,0.6,0.8,0.7c0.3-0.1,0.6-0.4,0.6-0.7c0-0.3-0.2-0.6-0.7-0.6 C463.7,434.6,463.4,434.9,463.4,435.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M499.2,438.2v-0.3l0.4-0.4c1-1,1.5-1.5,1.5-2.1c0-0.4-0.2-0.8-0.8-0.8c-0.4,0-0.7,0.2-0.8,0.3l-0.2-0.4 c0.3-0.2,0.7-0.4,1.1-0.4c0.9,0,1.2,0.6,1.2,1.2c0,0.7-0.5,1.3-1.4,2.1l-0.3,0.3v0h1.8v0.4H499.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M505,436.2c0,1.3-0.5,2.1-1.4,2.1c-0.8,0-1.3-0.7-1.3-2c0-1.3,0.6-2.1,1.4-2.1 C504.5,434.2,505,435,505,436.2z M502.8,436.3c0,1,0.3,1.6,0.8,1.6c0.5,0,0.8-0.6,0.8-1.7c0-1-0.2-1.6-0.8-1.6 C503.2,434.6,502.8,435.2,502.8,436.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.6,434.8L506.6,434.8l-0.7,0.4l-0.1-0.4l0.9-0.5h0.5v4h-0.5V434.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M508.9,437.9c0.1,0,0.2,0,0.4,0c0.3,0,0.6-0.2,0.8-0.4c0.3-0.2,0.5-0.6,0.5-1.1h0 c-0.2,0.3-0.5,0.4-0.9,0.4c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.4,1.4-1.4c0.8,0,1.3,0.7,1.3,1.7c0,0.9-0.3,1.5-0.7,1.9 c-0.3,0.3-0.7,0.5-1.2,0.5c-0.2,0-0.4,0-0.5,0V437.9z M509.1,435.6c0,0.5,0.3,0.8,0.8,0.8c0.4,0,0.6-0.2,0.8-0.4 c0,0,0-0.1,0-0.2c0-0.7-0.2-1.2-0.8-1.2C509.4,434.6,509.1,435,509.1,435.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 299.3,
    className: "st21",
    width: 134.6,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 343,
    className: "st21",
    width: 134.6,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 386.6,
    className: "st21",
    width: 134.6,
    height: 21.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 299.3,
    className: "st9",
    width: 60.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 308.5,
    className: "st22",
    width: 103.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 317.7,
    className: "st10",
    width: 37,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 343,
    className: "st9",
    width: 109.2,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 352.1,
    className: "st22",
    width: 44.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 361.3,
    className: "st10",
    width: 89.8,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 386.9,
    className: "st9",
    width: 44.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 396,
    className: "st22",
    width: 89.8,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 405.2,
    className: "st10",
    width: 74.1,
    height: 3.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 708.6,
    y1: 277,
    x2: 708.6,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 674.6,
    y1: 277,
    x2: 674.6,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 640.6,
    y1: 277,
    x2: 640.6,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 606.5,
    y1: 277,
    x2: 606.5,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 640.6,
    y: 277,
    className: "st21",
    width: 68.1,
    height: 83.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 572.5,
    y: 277,
    className: "st23",
    width: 170.2,
    height: 83.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 742.7,
    y1: 346.6,
    x2: 572.5,
    y2: 346.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 572.5,
    y1: 332.7,
    x2: 742.7,
    y2: 332.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 572.5,
    y1: 318.8,
    x2: 742.7,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 572.5,
    y1: 304.8,
    x2: 742.7,
    y2: 304.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 572.5,
    y1: 290.9,
    x2: 742.7,
    y2: 290.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,359.8c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,357.9,569.6,358.6,569.6,359.8z M567.6,359.8c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,358.3,567.6,358.8,567.6,359.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M565.4,344.5L565.4,344.5l-0.6,0.3l-0.1-0.4l0.8-0.4h0.4v3.6h-0.5V344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,345.8c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,344,569.6,344.7,569.6,345.8z M567.6,345.9c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,344.4,567.6,344.9,567.6,345.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M564.3,333.7v-0.3l0.4-0.4c0.9-0.9,1.3-1.3,1.3-1.9c0-0.4-0.2-0.7-0.7-0.7c-0.3,0-0.6,0.2-0.8,0.3 l-0.2-0.3c0.3-0.2,0.6-0.4,1-0.4c0.8,0,1.1,0.5,1.1,1.1c0,0.7-0.5,1.2-1.2,1.9l-0.3,0.3v0h1.6v0.4H564.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,331.8c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,330,569.6,330.7,569.6,331.8z M567.6,331.9c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,330.4,567.6,330.9,567.6,331.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M564.5,319.2c0.1,0.1,0.5,0.2,0.8,0.2c0.6,0,0.8-0.4,0.8-0.7c0-0.5-0.5-0.7-0.9-0.7h-0.3v-0.4h0.3 c0.4,0,0.8-0.2,0.8-0.6c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.6,0.1-0.7,0.2l-0.1-0.4c0.2-0.1,0.6-0.3,0.9-0.3c0.7,0,1,0.4,1,0.9 c0,0.4-0.2,0.7-0.7,0.9v0c0.4,0.1,0.8,0.4,0.8,0.9c0,0.6-0.4,1.1-1.3,1.1c-0.4,0-0.8-0.1-0.9-0.2L564.5,319.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,317.9c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,316,569.6,316.7,569.6,317.9z M567.6,317.9c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,316.4,567.6,316.9,567.6,317.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M565.9,305.8v-1h-1.7v-0.3l1.6-2.3h0.5v2.2h0.5v0.4h-0.5v1H565.9z M565.9,304.4v-1.2 c0-0.2,0-0.4,0-0.6h0c-0.1,0.2-0.2,0.4-0.3,0.5l-0.9,1.2v0H565.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,303.9c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,302.1,569.6,302.8,569.6,303.9z M567.6,304c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,302.5,567.6,303,567.6,304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M566.5,288.6h-1.4l-0.1,0.9c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.1,0.8,0.2c0.3,0.2,0.5,0.5,0.5,0.9 c0,0.7-0.6,1.2-1.3,1.2c-0.4,0-0.7-0.1-0.9-0.2l0.1-0.4c0.2,0.1,0.4,0.2,0.8,0.2c0.5,0,0.9-0.3,0.9-0.8c0-0.5-0.3-0.8-1-0.8 c-0.2,0-0.4,0-0.5,0l0.2-1.7h1.7V288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.6,289.9c0,1.2-0.5,1.9-1.3,1.9c-0.7,0-1.2-0.7-1.2-1.9c0-1.2,0.5-1.9,1.3-1.9 C569.2,288.1,569.6,288.8,569.6,289.9z M567.6,290c0,0.9,0.3,1.5,0.7,1.5c0.5,0,0.7-0.6,0.7-1.5c0-0.9-0.2-1.5-0.7-1.5 C568,288.5,567.6,289,567.6,290z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M589,365.1L589,365.1l-0.6,0.3l-0.1-0.3l0.7-0.4h0.4v3.4H589V365.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M622,368.1v-0.3l0.4-0.3c0.9-0.8,1.3-1.3,1.3-1.8c0-0.3-0.2-0.7-0.7-0.7c-0.3,0-0.6,0.2-0.7,0.3 l-0.1-0.3c0.2-0.2,0.6-0.3,1-0.3c0.7,0,1,0.5,1,1c0,0.6-0.5,1.1-1.2,1.8l-0.3,0.3v0h1.5v0.4H622z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M656.2,367.6c0.1,0.1,0.4,0.2,0.8,0.2c0.6,0,0.8-0.4,0.8-0.7c0-0.5-0.4-0.7-0.9-0.7h-0.3v-0.3h0.3 c0.3,0,0.8-0.2,0.8-0.6c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.5,0.1-0.7,0.2l-0.1-0.3c0.2-0.1,0.5-0.3,0.9-0.3c0.7,0,1,0.4,1,0.8 c0,0.3-0.2,0.6-0.6,0.8v0c0.4,0.1,0.8,0.4,0.8,0.9c0,0.5-0.4,1-1.2,1c-0.4,0-0.7-0.1-0.9-0.2L656.2,367.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M691.5,368.1v-0.9h-1.6v-0.3l1.5-2.2h0.5v2.1h0.5v0.4h-0.5v0.9H691.5z M691.5,366.8v-1.1 c0-0.2,0-0.4,0-0.5h0c-0.1,0.2-0.2,0.3-0.3,0.5l-0.8,1.2v0H691.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M726.2,365.1h-1.3l-0.1,0.9c0.1,0,0.2,0,0.3,0c0.3,0,0.5,0.1,0.7,0.2c0.3,0.2,0.5,0.4,0.5,0.9 c0,0.7-0.5,1.2-1.3,1.2c-0.4,0-0.7-0.1-0.8-0.2l0.1-0.3c0.1,0.1,0.4,0.2,0.7,0.2c0.4,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.8-1-0.8 c-0.2,0-0.3,0-0.5,0l0.2-1.6h1.6V365.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "572.5,361.1 606.5,347.2 640.6,332.3 674.6,318.5 708.9,318.5 742.7,304.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st25",
    points: "572.5,346.6 606.5,332.7 640.6,346.6 674.6,333.7 708.6,291.8 742.7,277  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M710.6,291.8c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9 C709.7,289.8,710.6,290.7,710.6,291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M676.5,333.7c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9 C675.7,331.7,676.5,332.6,676.5,333.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M642.5,346.6c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9 C641.6,344.7,642.5,345.5,642.5,346.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M608.5,332.7c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9 C607.6,330.7,608.5,331.6,608.5,332.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M675.8,318.7c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9 C674.9,316.8,675.8,317.6,675.8,318.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M710.6,318.7c0,1.1-0.9,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9 C709.7,316.8,710.6,317.6,710.6,318.7z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 249.1,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 256.8,
    className: "st5",
    width: 26.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 276.8,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 284.4,
    className: "st5",
    width: 26.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 304.4,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 312.1,
    className: "st5",
    width: 26.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 332,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 339.7,
    className: "st5",
    width: 26.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 359.7,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 367.3,
    className: "st5",
    width: 26.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 387.3,
    className: "st5",
    width: 6.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 395,
    className: "st5",
    width: 26.1,
    height: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M835.2,297.3c-5.8,5.3-10.6,17.5-17.6,60.6c-0.2,1.4-16.9,12.3-16.9,12.3l31.2,6.5l0.7-19.8 c0,0-1.6-11.2-1.4-44C831.3,303.1,835.6,296.9,835.2,297.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M906.4,453.7c2.1,0,5.3-0.5,8.1-2.9c4.1-3.6,5.9-9.9,5.3-18.8c-0.4-6-2.8-12.1-5.3-18.6 c-4.2-10.8-9-23.1-6.5-39.4l-4.6-0.7c-2.7,17.5,2.6,31,6.8,41.8c2.5,6.4,4.6,11.9,5,17.2c0.5,7.2-0.8,12.4-3.6,14.9 c-2.7,2.4-6.1,1.8-6.2,1.7l-0.9,4.6C904.5,453.5,905.2,453.7,906.4,453.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M870.4,491l-4.6,7l38.4,12.3c0,0,2.6-2.5-6.9-7.4C886.4,497.1,870.4,491,870.4,491z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M863.6,491l4.6,7l-38.4,12.3c0,0-2.6-2.5,6.9-7.4C847.6,497.1,863.6,491,863.6,491z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 863,
    y: 470.2,
    className: "st29",
    width: 8,
    height: 28.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M870.9,492.4l-3.9,6.7l32.9,11.7c0,0,2.2-2.3-5.9-7.1C884.6,498.3,870.9,492.4,870.9,492.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M863.1,492.4l3.9,6.7l-32.9,11.7c0,0-2.2-2.3,5.9-7.1C849.4,498.3,863.1,492.4,863.1,492.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M896.2,513.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8 C897.4,510.7,896.2,511.9,896.2,513.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M832.4,513.5c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8c0-1.5-1.2-2.8-2.8-2.8 C833.7,510.7,832.4,511.9,832.4,513.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M902.9,513.5c0,1.5,1.3,2.8,2.8,2.8s2.8-1.2,2.8-2.8c0-1.5-1.2-2.8-2.8-2.8S902.9,511.9,902.9,513.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M825.7,513.5c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8 C826.9,510.7,825.7,511.9,825.7,513.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 864.2,
    y: 459.7,
    className: "st28",
    width: 5.9,
    height: 10.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M859.8,454.3c0,3.2,2.6,5.7,5.7,5.7h3.2c3.2,0,5.7-2.6,5.7-5.7l0,0c0-3.2-2.6-5.7-5.7-5.7h-3.2 C862.3,448.6,859.8,451.1,859.8,454.3L859.8,454.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M823.4,449.1c-0.1-0.7-0.2-4.9-0.2-5.6c0-4.6,3-8.4,6.7-8.4h74.4c3.7,0,6.7,3.7,6.7,8.4 c0,0.7-0.1,5-0.2,5.6H823.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M911.7,451.3c0,1.4-0.8,2.6-1.8,2.6h-85.4c-1,0-1.8-1.1-1.8-2.6l0,0c0-1.4,0.8-2.6,1.8-2.6h85.4 C910.8,448.8,911.7,449.9,911.7,451.3L911.7,451.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M907.5,406.1c-1.8,0.1-13.5,0.3-15.5,0.4c-12.8,0.2-23.8-2.2-24.4-5.4c-2.5-13.1-2.6-26.5-0.3-39.5 c0.5-3.1,11.7-5.5,24.7-5.4c2.1,0,14,0.2,15.8,0.4C903.8,372.8,903.7,389.8,907.5,406.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M909.3,356.5c1.4,0,2.4,0.7,2.2,1.5c-3.6,15.3-3.7,31.2-0.4,46.5c0.2,0.8-0.8,1.5-2.2,1.5l0,0 c-1.4,0-2.7-0.6-2.9-1.5c-3.3-15.4-3.2-31.3,0.3-46.7C906.5,357.2,907.8,356.5,909.3,356.5L909.3,356.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M909.8,406.1c-0.4,0.1-2.9,0.2-3.3,0.2c-2.8,0-5.6-2.4-6.2-5.5c-2.3-12.9-2.3-26.1,0.2-38.9 c0.6-3.1,3.5-5.5,6.4-5.5c0.4,0,3,0.1,3.4,0.2C906.2,372.8,906.1,389.8,909.8,406.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 821.2,
    y: 481.6,
    transform: "matrix(0.8631 -0.505 0.505 0.8631 -134.6791 484.9757)",
    className: "st28",
    width: 12.3,
    height: 18.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M797.4,416.5l38.3,74.9l-13.1,5.6c0,0-46.5-70.7-43.4-76.1C782.3,415.4,795.4,413.1,797.4,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M839.6,500.9l-7.7,4.5l-1.4-2.4l-2,4.3L809,518.8c0,0-1.5-3.4,11.3-11.6c3.3-2.1,3-8,3-8s0.8-2.5,5.4-0.4 c1.2,0.5,7.2-5.4,7.2-5.4S839.3,497.7,839.6,500.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M885.5,360.6c0,0,7.9,24.4,13.1,31.9c3.7,5.3,6.9,16.3,6.5,21.2c-0.4,4.9-0.9,20.8-9.4,21.6 c-12.3,1.2-35.5-0.4-35.5-0.4s-13.5-34.7-13.1-39.2c0.4-4.5,3.3-9.9,3.9-12.1c0.6-2.2-3.5-10.8-3.5-10.8L885.5,360.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M859,410l-65.5,34.2c0,0-22.7-23.1-13.3-29.2c18.2-11.9,70.9-31.3,70.9-31.3L859,410z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "791.6,504.8 790.6,522.4 776.8,522 780.5,501.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M894.9,435.3l-86.6-0.3c0,0-15.9-7.1-8.2-16.3c4.9-5.9,64.8-17.5,82.2-17.7 C917.4,400.6,894.9,435.3,894.9,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M821.4,433.3L793.3,518l-16.1-7c0,0,13.4-86.4,23-88.8C809.9,419.9,822.1,430.5,821.4,433.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M790.6,524.5l-9.4,0.3l-0.1-2.9l-4,3l-23.7,0.7c0,0,0.3-3.9,16.2-5c4.1-0.3,6.8-5.9,6.8-5.9s2-1.9,5.2,2.3 c0.8,1.1,9.4-1.3,9.4-1.3S791.9,521.4,790.6,524.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.3,
    y: 384.6,
    transform: "matrix(4.198074e-02 -0.9991 0.9991 4.198074e-02 469.7393 1260.9609)",
    className: "st33",
    width: 8.2,
    height: 1.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M851.4,292.7c16.1-1,36.2,3.2,39.4,14.7c3.7,13.3,1.1,59.7,13,88.4c0.4,1.1-0.3,4.2-2.5,3.9 c-12.8-1.4-51.6-1.8-51.6-1.8l-17.9-45.2l-2.9-24c0,0-1.8-28.2,7.5-33.7C838.4,293.7,845.3,293.1,851.4,292.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "624.2,534.8 614.9,534.8 630.2,386.4 643.7,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "642.8,393.2 636.9,438.2 629.9,389.7 630.2,386.4 642,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "748.6,534.8 739.3,534.8 754.6,386.4 768.1,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "767.2,393.2 761.3,438.2 754.3,389.7 754.6,386.4 766.4,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "846.1,534.8 855.4,534.8 840.1,386.4 826.6,386.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "827.5,393.2 845.5,439 840.4,389.7 840.1,386.4 828.3,386.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.1,
    y: 381.5,
    className: "st32",
    width: 112,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.1,
    y: 381.5,
    className: "st10",
    width: 127.2,
    height: 8.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M807.2,361.8c0,0-4.9-0.1-9.1,2.5c-3.2,2-6.1,6.2-3.2,8.5c2.9,2.3,7.4,4.4,7.4,4.4S813.5,377.5,807.2,361.8 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M851.1,352.8c0,0-9.8,16-28.2,18.5c-3.2,0.4-5.5,3.2-4.1,4.3c1.7,1.5,4.3,2,8.7,2.5 c9.3,1.1,22.3-0.1,32.1-6.7c14.5-9.8,19.3-14.5,18.8-20.3C877.9,345.3,851.1,352.8,851.1,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M888.2,302.8c3,6,3.9,15.2,2,28c-1.4,9.9-13.2,25.1-15.4,29.9c-0.4,0.8-1.4,4.3-1.4,4.3l-11.8,8.1 l-19.2-15.3l7.7-8.1l1.9,0.4c0,0,1.9-4.8,1.8-6.7c-0.1-1.9,9.7-26.8,15.1-42.9C871.9,291.3,885.2,296.9,888.2,302.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M862.2,351l-5.9-2.4l-2.4-0.8c-0.4,1.5-2,2.4-2,2.4l4.8,1.1l5.4,2.2l6,4.8L862.2,351z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M824.3,371.4l-10.4-3.9c0,0-3.6,3.3-3.1,4.3c0.4,1-0.9,6.4-0.9,6.4l4.6,4.6l4.4-0.8c0,0,0.5-1.6-0.9-2 c-1.4-0.3,1.1-1,1.9-1.3C820.8,378.4,827.4,376.2,824.3,371.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M838.7,379.4C838.7,379.4,838.8,379.4,838.7,379.4l0-2l-80.3-1.5l0,1.9c0,0,0,0,0,0.1l0.2,0.4 c1,1.7,2.8,2,5,2.1l69.9,1.3c2.1,0,4-0.2,5-1.9L838.7,379.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M819.4,379.4C819.4,379.4,819.4,379.4,819.4,379.4l0.2,0.4c0.3,0.4,0.7,0.8,1.2,1l12.2,0.2 c2,0,3.8-0.2,4.8-1.5l0.2-0.3c0,0,0,0,0-0.1l0-0.9l-18.6-0.3L819.4,379.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 787.8,
    y: 357.6,
    transform: "matrix(1.812324e-02 -0.9998 0.9998 1.812324e-02 396.6324 1159.1471)",
    className: "st41",
    width: 1.4,
    height: 40.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M819,377l-9.7-39.7c-0.3-1-1.3-1.9-2.3-1.9l-56.3-1c-1,0-1.7,0.8-1.4,1.9l9.7,39.7L819,377z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M787.5,355.7c0.5,2-0.7,3.6-2.8,3.6c-2,0-4.1-1.7-4.5-3.7c-0.5-2,0.7-3.6,2.8-3.6 C785,352,787,353.7,787.5,355.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M842.5,292.5c0.4,3.8,2.9,7.1,5.4,7.2c2.4,0,4.8-0.1,7.3-0.1c2.6-0.2,4.9-3.5,5.3-7.3 c0.5-6.3,1-12.6,1.5-18.9c0.3-3.8-1.5-11.3-5.4-13.5c-3.6-1.9-7.6-1.9-11.1,0.1c-3.8,2.3-5.5,9.9-5,13.6 C841.1,279.9,841.8,286.2,842.5,292.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "843.3,296.6 848.3,305.5 866.1,294.5 861.9,289.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "842.6,293.5 844,296.7 839.7,303.9 839.3,298.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M844.2,255.7l-1.1-4.6l-2.1,0.4l-5.5,1.1l-3.3,0.6c-3.7,0.7-6,4-5.2,7.3l1.1,4.6l2.1-0.4l5.5-1.1l3.3-0.6 C842.7,262.2,845,259,844.2,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M861.3,281.3c0.7,2.9-1.4,5.8-4.6,6.5l-13.4,2.6c-3.3,0.6-6.5-1.2-7.2-4.2l-5.8-24.2 c-0.7-2.9,1.4-5.9,4.6-6.5l13.4-2.6c3.3-0.6,6.5,1.2,7.2,4.2L861.3,281.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M843.6,251c2.3-0.5,4.6,0.2,6.2,1.6l2.3-0.4c2.8-0.5,5.6,1.1,6.3,3.7l2.7,11.5l-3.6,0.7l-1.1-4.7 c-0.4-1.8-2.4-3-4.4-2.6l-2.1,0.4l-5.5,1.1l-3.3,0.6c-3.7,0.7-7.3-1.4-8.1-4.7l-1.2-4.9L843.6,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M857,271.3c-0.4-1.6,0.7-3.1,2.5-3.5l0.3,0c1.7-0.3,3.5,0.7,3.8,2.2l0.8,3.5c0.4,1.6-0.7,3.1-2.5,3.5 l-0.3,0c-1.3,0.2-2.6-0.2-3.3-1.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M145.6,485.4c-3.5-5.4,0.9-10,17.5-12.4c18.2-2.7,35.5-0.8,49.8,2.4c-33.7-16.3-72.9-39.2-37.1-41.9 c11.2-0.8,28.4,4.6,47.5,13c-21.3-17.4-33.1-31.6-20.1-34.3c12-2.5,36.5,11.7,62.5,30.4c-14.8-15.7-23.4-29.4-16.8-35.9 c5.4-5.3,17,0.8,30.4,12c-0.6-9.9,3.6-15.8,13-14.6c8.9,1.1,16.1,12.5,21.3,26.2c8.5-21.2,31.1-34.2,53.8-27.8 c26.7,7.6,5.3,58.5-6.7,82.7H145.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M264.8,337.9c0,0,32.8,36.6,46.5,122.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M301,356.7c0,0,19.3,45.2,16.8,95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M269.7,390.1c0,0,31.1,18.1,29,64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M261.1,330.8c-7.4,3.9-12.1,9.4-10.5,12.4c1.6,3,8.8,2.3,16.2-1.6c7.4-3.9,12.1-9.4,10.5-12.4 C275.7,326.2,268.5,326.9,261.1,330.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M263,334.5c-2.3,1.2-3.8,3-3.3,3.9c0.5,0.9,2.8,0.7,5.1-0.5c2.3-1.2,3.8-3,3.3-3.9 C267.7,333.1,265.4,333.3,263,334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M299.5,353.8c-3.1,1.6-5,3.9-4.4,5.2c0.7,1.2,3.7,1,6.7-0.7c3.1-1.6,5-3.9,4.4-5.2 C305.5,351.9,302.5,352.1,299.5,353.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M300.3,355.3c-1,0.5-1.6,1.2-1.4,1.6c0.2,0.4,1.2,0.3,2.1-0.2c1-0.5,1.6-1.2,1.4-1.6 C302.2,354.7,301.2,354.8,300.3,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M267.5,387.7c-3.3,3-4.9,6.6-3.7,7.9c1.2,1.3,4.9-0.1,8.2-3.1c3.3-3,4.9-6.6,3.7-7.9 C274.4,383.3,270.7,384.7,267.5,387.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M269,389.3c-1,1-1.6,2.1-1.2,2.5c0.4,0.4,1.6,0,2.6-1c1-1,1.6-2.1,1.2-2.5 C271.2,387.9,270,388.4,269,389.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M245.6,449.2c-0.1-0.1-0.3-0.2-0.4-0.3c0.1,0,0.2-0.1,0.2-0.1c2-0.8,3.3-2.3,2.9-3.3 c-0.4-1-2.4-1.3-4.4-0.5c-0.2,0.1-0.3,0.1-0.5,0.2c0-0.1,0-0.2,0-0.2c0.3-2.1-0.3-4-1.4-4.1c-1.1-0.2-2.3,1.4-2.6,3.5 c0,0.2,0,0.4-0.1,0.5c-0.1-0.1-0.1-0.1-0.2-0.2c-1.7-1.3-3.6-1.7-4.3-0.8c-0.7,0.9,0.1,2.7,1.8,4c0.1,0.1,0.3,0.2,0.4,0.3 c-0.1,0-0.2,0.1-0.2,0.1c-2,0.8-3.3,2.3-2.9,3.3c0.4,1,2.4,1.3,4.4,0.5c0.2-0.1,0.3-0.1,0.5-0.2c0,0.1,0,0.2,0,0.2 c-0.3,2.1,0.3,4,1.4,4.1c1.1,0.2,2.3-1.4,2.6-3.5c0-0.2,0-0.4,0.1-0.5c0.1,0.1,0.1,0.1,0.2,0.2c1.7,1.3,3.6,1.7,4.3,0.8 C248.1,452.4,247.3,450.6,245.6,449.2z M240.9,450.7c-1.1-0.2-1.9-1.2-1.8-2.4c0.2-1.1,1.2-1.9,2.4-1.8c1.1,0.2,1.9,1.2,1.8,2.4 C243.1,450.1,242,450.9,240.9,450.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M810.6,269.7h-46c-2.8,0-5.1,2.3-5.1,5.1v35.8c0,2.8,2.3,5.1,5.1,5.1h15.3l2.6,2.6l5.1,5.1l5.1-5.1l2.6-2.6 h15.3c2.8,0,5.1-2.3,5.1-5.1v-35.8C815.7,272,813.4,269.7,810.6,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M805.5,295.3v-5.1h-5.4c-0.3-1.6-1-3.1-1.9-4.5l3.8-3.8l-3.6-3.6l-3.8,3.8c-1.3-0.9-2.9-1.5-4.5-1.9v-5.4 H785v5.4c-1.6,0.3-3.1,1-4.5,1.9l-3.8-3.8l-3.6,3.6l3.8,3.8c-0.9,1.3-1.5,2.8-1.9,4.5h-5.4v5.1h5.4c0.3,1.6,1,3.1,1.9,4.5 l-3.8,3.8l3.6,3.6l3.8-3.8c1.3,0.9,2.9,1.5,4.5,1.9v5.4h5.1v-5.4c1.6-0.3,3.1-1,4.5-1.9l3.8,3.8l3.6-3.6l-3.8-3.8 c0.9-1.3,1.5-2.9,1.9-4.5H805.5z M787.6,300.4c-4.2,0-7.7-3.4-7.7-7.7c0-4.2,3.4-7.7,7.7-7.7c4.2,0,7.7,3.4,7.7,7.7 C795.2,296.9,791.8,300.4,787.6,300.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M717,41.5c-14.8,0-26.9,12-26.9,26.9c0,14.9,26.9,55.6,26.9,55.6s26.9-40.7,26.9-55.6 C743.9,53.5,731.9,41.5,717,41.5z M717,77.8c-4.4,0-7.9-3.6-7.9-8c0-4.4,3.6-8,7.9-8c4.4,0,8,3.6,8,8 C725,74.3,721.4,77.8,717,77.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M243.7,249.9v37.7c0,2.8,2.3,5,5,5h47.6c2.8,0,5-2.3,5-5v-11.3l2.5-2.5l5-5l-5-5l-2.5-2.5v-11.2 c0-2.8-2.3-5-5-5h-47.6C245.9,244.9,243.7,247.1,243.7,249.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M259.3,268L259.3,268l7.3,3.2v4.1l-11.3-5.6v-3.5l11.3-5.5v4.1L259.3,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M271.2,278.2h-3.1l6.6-24.1h3.1L271.2,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M287.2,268L287.2,268l-7.4-3.2v-4.1l11.3,5.5v3.5l-11.3,5.6v-4.1L287.2,268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M359.7,109.3h-48.7c-3,0-5.4,2.4-5.4,5.4v37.9c0,3,2.4,5.4,5.4,5.4h16.2l2.7,2.7l5.4,5.4l5.4-5.4l2.7-2.7 h16.2c3,0,5.4-2.4,5.4-5.4v-37.9C365.2,111.7,362.7,109.3,359.7,109.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M326.1,148.3c-1.8-0.6-3.1-1.6-3.9-2.9c-0.8-1.3-1.2-2.9-1.2-4.7v-3.4c0-1.1-0.2-1.9-0.6-2.5 c-0.4-0.6-0.9-0.9-1.7-0.9v-3.3c0.8,0,1.3-0.3,1.7-0.9c0.4-0.6,0.6-1.4,0.6-2.5v-3.4c0-1.9,0.4-3.4,1.2-4.7 c0.8-1.3,2.1-2.2,3.9-2.8l0.9,2.6c-0.7,0.3-1.1,0.9-1.4,1.8s-0.4,1.9-0.4,3.2v3.4c0,1.1-0.2,2.1-0.7,3c-0.4,0.9-1.1,1.6-2,2 c0.9,0.5,1.6,1.2,2,2.1c0.5,0.9,0.7,1.9,0.7,3v3.4c0,1.3,0.1,2.4,0.4,3.2c0.3,0.8,0.7,1.4,1.4,1.8L326.1,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M343,145.7c0.7-0.3,1.1-0.9,1.4-1.8c0.3-0.8,0.4-1.9,0.4-3.2v-3.4c0-1.1,0.2-2.1,0.7-3 c0.4-0.9,1.1-1.6,2.1-2c-0.9-0.5-1.6-1.2-2.1-2c-0.4-0.9-0.7-1.9-0.7-3v-3.4c0-1.3-0.1-2.4-0.4-3.2c-0.3-0.9-0.7-1.5-1.4-1.8 l0.9-2.6c1.8,0.6,3.1,1.5,3.9,2.8c0.8,1.3,1.2,2.9,1.2,4.7v3.4c0,1.1,0.2,1.9,0.5,2.5c0.4,0.6,0.9,0.9,1.7,0.9v3.3 c-0.8,0-1.4,0.3-1.7,0.9c-0.4,0.6-0.5,1.4-0.5,2.5v3.4c0,1.8-0.4,3.4-1.2,4.7c-0.8,1.3-2.1,2.3-3.9,2.9L343,145.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration01);
export default __webpack_public_path__ + "static/media/illustration_01.f0a256cf906bbbd6e1bdc72e350d769f.svg";
export { ForwardRef as ReactComponent };